import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toggleProfileCompletionModal } from '../../../../actions/common/modals';
import ChefIcon from '../../../../assets/images/profile/completion/chef.svg';
import ProfileCompletionCompleted from './ProfileCompletionCompleted';

const texts = {
    title: 'What do you Specialise in?',
    helper: 'Select the specialisations that matches your profile the most.',
    btn: '+Specialisations'
}

class SpecialisationsCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasProfileCompleted: (this.props.profile
                && this.props.profile.profile_specializations
                && !!this.props.profile.profile_specializations.length)
        }
        // binding toggle modal
        this.toggleModal = this.toggleModal.bind(this);
    }

    toggleModal() {
        const { toggleProfileCompletionModal } = this.props;
        toggleProfileCompletionModal('specialization');
    }

    componentDidUpdate() {
        if (this.props.profile
            && this.props.profile.profile_specializations
            && this.props.profile.profile_specializations.length
            && !this.state.hasProfileCompleted) {
            this.setState({
                hasProfileCompleted: true
            })
        }
    }

    render() {
        return (<div className="feed-common-cards profile-completion-card">
            <div className="profile-completion-card__image__container">
                <img className="profile-completion-card__image" src={ChefIcon} alt={texts.title} />
            </div>
            <div className="profile-completion-card__details">
                    <p className="profile-completion-card__details__title">{texts.title}</p>
                    <p className="profile-completion-card__details__helper">{texts.helper}</p>
            </div>
            <div className="profile-completion-card__action">
                <button className="profile-completion-card__action__btn" onClick={this.toggleModal}>
                    <span className="profile-completion-card__action__btn__text">{texts.btn}</span>
                </button>
            </div>
            { this.state.hasProfileCompleted && <ProfileCompletionCompleted /> }
        </div>)
    }
};

function mapStateToProps(state) {
    return {
        token: state.login.token,
    };
}

const mapDispatchToProps = {
    toggleProfileCompletionModal
}

export default connect(mapStateToProps, mapDispatchToProps)(SpecialisationsCard);